import { z } from "zod";

export const loginSchema = z.object({
    email: z.string().email('Digite um email válido').min(1, { message: 'Campo "Email" é obrigatório.' }),
    password: z.string().min(1, { message: 'Campo "Senha" é obrigatório.' }),
});